export default __webpack_public_path__ + "images/Schuette_grau_Values.webp?68aab5c5fd2dc52d07606feaad534b4f";